import Constants from '../../constants/column-name/column-name.constants';

export default {
  Customer: {
    store: 'Customer',
    lookups: {
      idField: Constants.Customer.customerId.field,
      codeField: Constants.Customer.customerCode.field,
      nameField: Constants.Customer.customerName.field,
      searchField: Constants.Customer.customerSearchField.field
    },
    formProps: {
      idField: Constants.User.customerId.field,
      codeField: Constants.User.customerCode.field,
      nameField: Constants.User.customerName.field
    },
    optionLabelProp: Constants.User.customerCode.field,
    infoField: 'customerInfoComments',
    isServerSide: true,
    serverSearchKey: 'CustomerSearchFieldQuery',
    serverIdKey: 'CustomerIdQuery'
  },
  ThirdParty: {
    store: 'ThirdParty',
    lookups: {
      idField: 'thirdPartyName',
      codeField: 'thirdPartyName',
      nameField: 'thirdPartyName'
    },
    formProps: {
      idField: Constants.User.thirdParty.field,
      codeField: Constants.User.thirdParty.field,
      nameField: Constants.User.thirdParty.field
    },
    isServerSide: true,
    serverSearchKey: 'ThirdPartySearchFieldQuery',
    searchOnOpen: true
  }
};
